import React, { Component } from "react";
import Switch from "react-switch";
import Delayed from "./Delayed";
import Typing from "./Typing";
import Logo from "./Logo";

class Header extends Component {
  titles = [];

  constructor() {
    super();
    this.state = { checked: false };
    this.onThemeSwitchChange = this.onThemeSwitchChange.bind(this);
  }

  onThemeSwitchChange(checked) {
    this.setState({ checked });
    this.setTheme();
  }

  setTheme() {
    var dataThemeAttribute = "data-theme";
    var body = document.body;
    const lightTheme = "#B8DBF7"
    const darkTheme = "#1F1F1F"
    var newTheme = body.getAttribute(dataThemeAttribute) === "dark" ? "light" : "dark";
    body.setAttribute(dataThemeAttribute, newTheme);
    newTheme === "light" ? this.setBrowserTheme(lightTheme) : this.setBrowserTheme(darkTheme);
  }
  
  setBrowserTheme(color) {
    document
      .querySelector("meta[name='theme-color']")
      .setAttribute("content", color)
  }

  render() {
    if (this.props.sharedData && this.props.resumeBasicInfo) {
      var name = this.props.sharedData.name;
      this.titles = this.props.resumeBasicInfo.titles.map(x => [ x, 1500 ] ).flat();
    }

    const HeaderTitleTypeAnimation = React.memo( () => {
      return <Typing className="title-styles" steps={this.titles} loop={50} />
    }, (props, prevProp) => true);

    return (
      <header id="home" style={{ height: window.innerHeight - 140, display: 'block' }}>
        <div className="row aligner" style={{height: '100%'}}>
          <div className="col-md-12">
            <div className="hero">
              <div className="aa-svg">
                <Logo/>
              </div>
              <br/>
              <h1 className="mb-0">
                <Typing steps={[name]} wrapper="p" />
              </h1>
              <div className="title-container">
                <Delayed waitBeforeShow={2000}>
                  <HeaderTitleTypeAnimation />
                </Delayed>
              </div>
              <Switch
                checked={this.state.checked}
                onChange={this.onThemeSwitchChange}
                offColor="#1e56a0"
                onColor="#5b5b5b"
                className="react-switch mx-auto"
                width={90}
                height={40}
                uncheckedIcon={
                  <span
                    className="iconify"
                    data-icon="emojione:crescent-moon"
                    data-inline="false"
                    style={{
                      display: "block",
                      height: "100%",
                      fontSize: 25,
                      textAlign: "end",
                      marginLeft: "20px",
                      color: "#353239",
                    }}
                  ></span>
                }
                checkedIcon={
                  <span
                    className="iconify"
                    data-icon="noto-v1:sun-with-face"
                    data-inline="false"
                    style={{
                      display: "block",
                      height: "100%",
                      fontSize: 25,
                      textAlign: "end",
                      marginLeft: "10px",
                      color: "#1F1F1F",
                    }}
                  ></span>
                }
                id="icon-switch"
              />
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
